import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import AddReleaseNote from '@/components/manage-release-notes/add-release-note';
import ManageReleaseFormContent from '@/components/manage-release-notes/manage-release-form-content';
import ReleaseNoteContent from '@/components/manage-release-notes/release-note-content';
import useBreakpoint from '@/hooks/use-break-point';
import { cn } from '@/lib/utils';

const ManageReleaseNotes = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isTablet = useBreakpoint('tablet');

  const isFormVisible = location.hash === '#release-note-form';
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');

  let heading = t('header.manage_release_notes');

  if (isFormVisible) {
    heading = id ? t('header.edit_release_note') : t('header.add_release_note');
  }

  const onClickAddReleaseNote = () => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.delete('id');
    const queryString = newSearchParams.toString();

    navigate({
      pathname: location.pathname,
      search: queryString ? `?${queryString}` : '',
      hash: 'release-note-form',
    });
  };

  const onEditReleaseNote = (id: string | number) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('id', id.toString());
    const queryString = newSearchParams.toString();

    navigate({
      pathname: location.pathname,
      search: queryString ? `?${queryString}` : '',
      hash: 'release-note-form',
    });
  };

  return (
    <div className={cn('flex flex-col h-full w-full gap-8', { 'pb-5': isTablet })}>
      <div
        className={cn('flex items-center justify-between gap-3 w-full', {
          'flex-wrap': isTablet,
        })}
      >
        <div className={cn({ 'pt-6': isTablet })}>
          <h1 className="text-2xl font-semibold">{heading}</h1>
          {!isFormVisible && (
            <span className="text-sm text-gray-500">{t('release_note.description')}</span>
          )}
        </div>
        {!isFormVisible && <AddReleaseNote onClick={onClickAddReleaseNote} />}
      </div>
      {!isFormVisible && (
        <ReleaseNoteContent onClick={onClickAddReleaseNote} onEdit={onEditReleaseNote} />
      )}
      {isFormVisible && <ManageReleaseFormContent />}
    </div>
  );
};

export default ManageReleaseNotes;
